module.exports = __webpack_public_path__ + "img/bg.52962dc1.png";